export default {
      id: "wit_icon_kruis-usage",
      viewBox: "0 0 36 36",
      url: __webpack_public_path__ + "sprite.6656901b3ab9be5618a76678ad156ea6.svg#wit_icon_kruis-usage",
      toString: function () {
        return this.url;
      }
    }